module.exports = __webpack_public_path__ + "static/img/bystage_white_02.30ac9bf6.svg";